// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disabled[data-v-782b47fa]{--tw-bg-opacity:1;background-color:rgba(229,231,235,var(--tw-bg-opacity));border-width:1px;--tw-border-opacity:1;border-color:rgba(209,213,219,var(--tw-border-opacity));--tw-text-opacity:1;color:rgba(75,85,99,var(--tw-text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
